export type Receipt = {
  category: string;
  title: string;
  /** Issuer or role, shown under the title */
  source?: string;
  description: string;
};

export const receiptsIntro =
  "The work should do most of the talking. Here are a few of my most recent recognitions, credentials and professional connections.";

export const receipts: Receipt[] = [
  {
    category: "Recognition",
    title: "Innovation Award",
    source: "Lawrence University · 2025",
    description: "Recognition for innovation in digital strategy and experience.",
  },
  {
    category: "Certification",
    title: "Generative AI: Impact, Considerations, and Ethical Issues",
    source: "IBM",
    description: "Focused on the impact, considerations and ethical questions surrounding generative AI.",
  },
  {
    category: "Community",
    title: "Orange Labs",
    source: "Member",
    description: "Part of a professional community exploring emerging technology, innovation and what comes next.",
  },
];
